module.exports = __webpack_public_path__ + "static/img/pic2.75d6cec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic2.jpg
// module id = 4OB5
// module chunks = 0